export default __webpack_public_path__ + "static/media/mg.731ebc37.svg";